import { defineComponent as _defineComponent } from 'vue'
import UiAuditInfo from '@/components/UiAuditInfo.vue';
import { Permission, ScheduleWeekday, WorkScheduleModel } from '@/types';
import { CheckCircleIcon, PencilAltIcon, XCircleIcon } from '@heroicons/vue/outline';
import { CalendarIcon, ClockIcon } from '@heroicons/vue/solid';
import { computed, PropType } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'WorkScheduleListItem',
  props: {
    modelValue: {
        type: Object as PropType<WorkScheduleModel>,
        required: true,
    },
},
  emits: ['activate', 'inactivate'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const { t } = useI18n();

const weekdays: ScheduleWeekday[] = [
    ScheduleWeekday.SUNDAY,
    ScheduleWeekday.MONDAY,
    ScheduleWeekday.TUESDAY,
    ScheduleWeekday.WEDNESDAY,
    ScheduleWeekday.THURSDAY,
    ScheduleWeekday.FRIDAY,
    ScheduleWeekday.SATURDAY,
];

const workDays = computed(() => {
    return weekdays.filter((day: ScheduleWeekday) => props.modelValue[day]);
});

const formatDayLabel = (day: ScheduleWeekday) => t('schedule.labels.' + day.toLocaleLowerCase());
const emit = __emit;
const handleActivateClick = () => emit('activate', props.modelValue);
const handleInactivateClick = () => emit('inactivate', props.modelValue);

const __returned__ = { props, t, weekdays, workDays, formatDayLabel, emit, handleActivateClick, handleInactivateClick, UiAuditInfo, get Permission() { return Permission }, get CheckCircleIcon() { return CheckCircleIcon }, get PencilAltIcon() { return PencilAltIcon }, get XCircleIcon() { return XCircleIcon }, get CalendarIcon() { return CalendarIcon }, get ClockIcon() { return ClockIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})